'use strict';

import NS from 'src/ns';
import platform from 'platform';
import { toPascalCase } from 'src/utility/string';

let detect = {
  os: {
    name: null,
    version: null
  },
  browser: {
    name: null,
    version: null
  },
  device: {
    isPC: false,
    isTablet: false,
    isMobile: false
  },
  addClass: function() {
    $('html')
      .addClass('-' + this.browser.name);
  }
};

/**
 * @param {string} ua
 * @param {object} ontouchstart
 * @return {{isPC: boolean, isTablet: boolean, isMobile: boolean, isTouch: boolean}}
 * @private
 */
function _getDevice(ua, ontouchstart) {
  const isTablet = (ua.indexOf('windows') != -1 && ua.indexOf('touch') != -1 && ua.indexOf('tablet pc') == -1)
    || ua.indexOf('ipad') != -1
    || (ua.indexOf('android') != -1 && ua.indexOf('mobile') == -1)
    || (ua.indexOf('firefox') != -1 && ua.indexOf('tablet') != -1)
    || ua.indexOf('kindle') != -1
    || ua.indexOf('silk') != -1
    || ua.indexOf('playbook') != -1;
  const isMobile = (ua.indexOf('windows') != -1 && ua.indexOf('phone') != -1)
    || ua.indexOf('iphone') != -1
    || ua.indexOf('ipod') != -1
    || (ua.indexOf('android') != -1 && ua.indexOf('mobile') != -1)
    || (ua.indexOf('firefox') != -1 && ua.indexOf('mobile') != -1)
    || ua.indexOf('blackberry') != -1;
  const isPC = !isTablet && !isMobile ? true: false;
  const isTouch = ontouchstart === null ? true: false;

  return {
    isPC: isPC,
    isTablet: isTablet,
    isMobile: isMobile,
    isTouch: isTouch
  }
}

(function(global) {
  const ua = global.navigator.userAgent.toLocaleLowerCase();
  const onTouchStart = global.ontouchstart;

  detect.os.name = platform.os.family;
  detect.os.version = platform.os.version;
  detect.browser.name = toPascalCase(platform.name.replace(' ', '')) || null;
  detect.browser.version = platform.version || null;
  detect.device = _getDevice(ua, onTouchStart);
})(window);

export default NS.detect = detect;


// WEBPACK FOOTER //
// ./htdocs/assets/src/javascripts/utility/detect.js